/**
 * Format a Per Square Foot value with exactly 2 decimal places and thousand separators.
 * Returns a string with "$" prefix.
 * Examples: "$0.25", "$12.50", "$3.00", "$1,234.56"
 */
export const formatPSF = (value: number): string =>
  `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
